export const DASHBOARD_VIDEO_PATH = 'dashboardContent/welcomeVideo';
export const DASHBOARD_VIDEO_TEST_CONFIG = Object.freeze({
  visibility: true,
  version: 'welcome-1',
  title: 'Un messaggio per te',
  subtitle: 'Guarda il video del team Fusco Fit',
  videoUrl: 'https://www.metodofusco.it/tickets/media/video_dashboard/test.mp4',
  posterUrl: '',
  link: '',
  linkLabel: 'Scopri di più',
  autoOpen: true,
});

function secureHttpsUrl(value) {
  if (typeof value !== 'string' || value.length > 2000) return '';
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch (_) {
    return '';
  }
}

// Invalid/missing documents deliberately hide the card, including after deletion.
export function normalizeDashboardVideo(value) {
  if (!value) return null;
  // visibility is the single current switch; enabled supports older documents only.
  const visible = Object.prototype.hasOwnProperty.call(value, 'visibility')
    ? value.visibility === true : value.enabled === true;
  if (!visible) return null;
  const videoUrl = secureHttpsUrl(value.videoUrl);
  const version = typeof value.version === 'string' ? value.version.trim() : '';
  if (!videoUrl || !/^[a-zA-Z0-9_-]{1,80}$/.test(version)) return null;
  const text = (input, fallback, limit) => typeof input === 'string' && input.trim()
    ? input.trim().slice(0, limit) : fallback;
  return {
    visibility: true,
    version,
    videoUrl,
    posterUrl: secureHttpsUrl(value.posterUrl),
    link: secureHttpsUrl(value.link),
    linkLabel: text(value.linkLabel, 'Scopri di più', 60),
    title: text(value.title, 'Un messaggio per te', 100),
    subtitle: text(value.subtitle, 'Guarda il video del team Fusco Fit', 160),
    autoOpen: value.autoOpen === true,
  };
}

export function dashboardVideoSeenKey(uid, version) {
  return `fuscofit:dashboard-video:${encodeURIComponent(uid)}:${encodeURIComponent(version)}`;
}

export function hasLocalVideoReceipt(storage, uid, version) {
  try {
    return storage?.getItem(dashboardVideoSeenKey(uid, version)) === '1';
  } catch (_) {
    return false;
  }
}

export function saveLocalVideoReceipt(storage, uid, version) {
  try {
    storage?.setItem(dashboardVideoSeenKey(uid, version), '1');
  } catch (_) {
    // Private browsing/full storage must not break the dashboard.
  }
}

export function withVideoTimeout(promise, milliseconds = 6000) {
  let timer;
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error('dashboard-video-timeout')), milliseconds);
    }),
  ]).finally(() => clearTimeout(timer));
}
